declare global {
  interface Window {
    appConfig: {
      REACT_APP_APP_ID: string;
      REACT_APP_AGROKOLL_API_URL: string;
      REACT_APP_LANTBRUKARE_IAM_CLIENTID: string;
      REACT_APP_LANTBRUKARE_IAM_AUTHORITY: string;
      REACT_APP_B2B_IAM_CLIENTID: string;
      REACT_APP_B2B_IAM_AUTHORITY: string;
      REACT_APP_AGRONOD_KONTO_URL: string;
    };
  }
}

const config = {
  REACT_APP_APP_ID: window.appConfig?.REACT_APP_APP_ID || "local-agrokoll-frontend",
  REACT_APP_AGROKOLL_API_URL: window.appConfig?.REACT_APP_AGROKOLL_API_URL || "http://localhost:5000",
};

export default config;
